import React from 'react';
import { GET_SECTIONS } from '../../graphql';
import Query from '../../../../graphql/Query';
import { SectionsQueryResult } from './types';
import SectionListView from './SectionListView';

const SectionList = () => (
    <Query<SectionsQueryResult> query={GET_SECTIONS}>
        {({ data: { sections } }) => (
            <SectionListView sections={sections} />
        )}
    </Query>
);

export default SectionList;
